import type { PostVerificationRequest } from './types';
import type { GetVerificationResponse } from '../get';

import { postGenericEndpoint, type PostGenericEndpointParams } from './post.api';

type VerificationType = 'email' | 'mobile';
type PostVerificationParams = PostGenericEndpointParams<PostVerificationRequest> & { type: VerificationType };

export const postVerification = async ({ data, lang, token, type }: PostVerificationParams): Promise<GetVerificationResponse> => {
    return await postGenericEndpoint({
        data,
        lang,
        token,
        path: `verify/${type}/validate`,
    });
};
